import { ClientEmployeeFragment } from "@graphql/client-employees/clientEmployees.g";

import { UpdateClientEmployeeForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";

type Props = {
  clientId: string;
  clientEmployeeId: string;
  onUpdateClientEmployeeSuccess?: (
    data: ClientEmployeeFragment,
  ) => Promise<void> | void;
};

export const UpdateClientEmployeeCard = ({
  clientId,
  clientEmployeeId,
  onUpdateClientEmployeeSuccess,
}: Props) => {
  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Update user</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <UpdateClientEmployeeForm
          clientId={clientId}
          clientEmployeeId={clientEmployeeId}
          onUpdateClientEmployeeSuccess={onUpdateClientEmployeeSuccess}
        />
      </Card.Body>
    </Card>
  );
};
